import { useTranslation } from 'react-i18next'
import { LockIcon } from '@phosphor-icons/react'
import { Typography } from '@/components/ui/typography'
import { formatMinutes } from '@/utils/date'
import { isFullDayTimeBlock } from '../helpers'

export const MonthTimeBlock = ({ timeBlock }) => {
  const { t } = useTranslation(['calendar'])

  return (
    <div className="ctp-reservation-event__inner timeBlock">
      <div className="header">
        <LockIcon />
        <Typography size="text-small">{`${timeBlock.reasonOther || timeBlock.reason} - ${timeBlock.amenityId?.name}`}</Typography>
      </div>
      {timeBlock.locationName && (
        <Typography size="text-small">{`${timeBlock.locationName}`}</Typography>
      )}
      <Typography size="text-small">
        {isFullDayTimeBlock({ startTime: timeBlock?.startTime, endTime: timeBlock?.endTime })
          ? t('calendar:messages.allDay')
          : `${formatMinutes(timeBlock?.startTime)} - ${formatMinutes(timeBlock?.endTime)}`}
      </Typography>
    </div>
  )
}
